/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import Magnific from "../vendors/magnific-popup.js";
import Swiper from "../vendors/swiper-bundle.min.js";
import gsap from "../vendors/gsap.min";
import ScrollTrigger from "../vendors/ScrollTrigger.min";
import Draggable from "../vendors/Draggable.min";
import "../vendors/slick.min";

jQuery(document).on("scroll", function () {
	if (jQuery(document).scrollTop() > 0) {
		jQuery("header, body").addClass("shrink");
	} else {
		jQuery("header, body").removeClass("shrink");
	}
});

/**
 * Document Ready Function
 * Triggered when document get's ready
 */

jQuery(document).ready(function () {
	// Function to set up custom cursor for a swiper-container
	function setupCustomCursor(slider) {
		const cursor = document.querySelector(".cursor-move");
		const cursorDot = cursor.querySelector(".cursor-dot");
		function moveCursor(event) {
			cursor.style.transition =
				"transform 0.2s cubic-bezier(0.25, 1, 0.5, 1)"; // Adding transition property
			cursor.style.transform = `translate3d(calc(${event.clientX}px - 50vw), calc(${event.clientY}px - 50vh), 0)`;
		}

		// To reset the transition after the movement is done
		function resetTransition() {
			cursor.style.transition = "none";
		}

		// Attach event listeners
		document.addEventListener("mousemove", moveCursor);
		document.addEventListener("transitionend", resetTransition);
		slider.addEventListener("mousemove", (event) => {
			moveCursor(event);
		});
		slider.addEventListener("pointermove", (event) => {
			moveCursor(event);
		});
		slider.addEventListener("mouseenter", () => {
			cursorDot.classList.add("show");
		});
		slider.addEventListener("mouseleave", () => {
			cursorDot.classList.remove("show");
		});
		slider.addEventListener("pointerdown", () => {
			cursorDot.classList.add("active");
		});
		slider.addEventListener("pointerup", () => {
			cursorDot.classList.remove("active");
		});
	}
	// Get all swiper-containers and apply custom cursor logic to each
	const swiperContainers = document.querySelectorAll(".swiper__cursor");
	swiperContainers.forEach((slider) => {
		setupCustomCursor(slider);
	});

	if (navigator.userAgent.indexOf("Mac OS X") != -1) {
		jQuery("body").addClass("style-for-apple");
	} else {
		jQuery("body").addClass("style-for-window");
	}

	if (document.body.classList.contains("single-property")) {
		// Add style to the HTML tag
		document.documentElement.style.overflowX = "hidden";
	}
	const windowWidth = jQuery(window).width();

	if (jQuery(".inline-video").length > 0) {
		const videoElement = document.getElementById("video");
		const videoDuration = 10; // Duration in seconds

		// Function to check video duration and handle classes
		function checkVideoDuration() {
			if (videoElement && videoElement.duration < videoDuration) {
				videoElement.play();
				jQuery("#video_progress").show();
			} else {
				videoElement.pause();
				jQuery(".inline-video").addClass("active");
				jQuery("#video_progress").hide();
			}
		}

		// Listen to the 'loadedmetadata' event to ensure the video duration is available
		if (videoElement) {
			videoElement.addEventListener("loadedmetadata", checkVideoDuration);
		}

		// Timeupdate event to update the video progress
		jQuery("#video").on("timeupdate", updateProgress);

		const videoProgress = document.getElementById("video_progress");

		// Function to update the video progress
		function updateProgress() {
			if (videoElement) {
				videoProgress.value = Math.round(
					(videoElement.currentTime / videoElement.duration) * 100
				);
			}
		}

		// Progress loop
		function progressLoop() {
			setInterval(function () {
				updateProgress();
				if (videoElement && videoElement.duration > videoDuration) {
					jQuery("#video_progress").hide();
				} else {
					jQuery("#video_progress").show();
				}
			});
		}

		progressLoop();
	}

	/**
	 * Script for gravity form label swap
	 */

	jQuery(
		'input[type="text"],input[type="email"],input[type="tel"],textarea'
	).each(function () {
		jQuery(this).parent().parent(".gfield").addClass("label-down");
	});

	jQuery('input[type="text"],input[type="email"],input[type="tel"]').each(
		function () {
			jQuery(this).on("focus", function () {
				jQuery(this).parent().parent(".gfield").addClass("active");
			});

			jQuery(this).on("blur", function () {
				if (jQuery(this).val().length == 0) {
					jQuery(this)
						.parent()
						.parent(".gfield")
						.removeClass("active");
				}
			});

			if (jQuery(this).val() != "") {
				jQuery(this).parent(".css").addClass("active");
			}
		}
	);

	jQuery("textarea").each(function () {
		jQuery(this).on("focus", function () {
			jQuery(this).parent().parent(".gfield").addClass("active");
		});

		jQuery(this).on("blur", function () {
			if (jQuery(this).val().length == 0) {
				jQuery(this).parent().parent(".gfield").removeClass("active");
			}
		});

		if (jQuery(this).val() != "") {
			jQuery(this).parent(".css").addClass("active");
		}
	});

	/**
	 * Hero Video
	 */

	if (jQuery(".icon-lists").length > 0) {
		const array = [];
		let html = "";
		jQuery(".icon-lists")
			.find(".lists__tiles")
			.each(function () {
				array.push(
					'<div class="lists__tiles column">' +
						jQuery(this).html() +
						"</div>"
				);
			});

		if (jQuery(window).width() > 1003) {
			const LogoSize = 3;
			const logochunk = [];
			for (let i = 0; i < array.length; i += LogoSize) {
				logochunk.push(array.slice(i, i + LogoSize));
			}
			for (const key in logochunk) {
				const element = logochunk[key];
				html += '<div class="icon-lists three-columns">';
				for (const key in element) {
					const el = element[key];
					html += el;
				}
				html += "</div>";
			}
		} else if (
			jQuery(window).width() <= 1003 &&
			jQuery(window).width() > 747
		) {
			const LogoSize = 2;
			const logochunk = [];
			for (let i = 0; i < array.length; i += LogoSize) {
				logochunk.push(array.slice(i, i + LogoSize));
			}
			for (const key in logochunk) {
				const element = logochunk[key];
				html += '<div class="icon-lists three-columns">';
				for (const key in element) {
					const el = element[key];
					html += el;
				}
				html += "</div>";
			}
		} else if (jQuery(window).width() <= 748) {
			const LogoSize = 1;
			const logochunk = [];
			for (let i = 0; i < array.length; i += LogoSize) {
				logochunk.push(array.slice(i, i + LogoSize));
			}
			for (const key in logochunk) {
				const element = logochunk[key];
				html += '<div class="icon-lists three-columns">';
				for (const key in element) {
					const el = element[key];
					html += el;
				}
				html += "</div>";
			}
		}

		jQuery(".icon-lists").html(html);
	}

	if (jQuery(".hero__company--video").length > 0) {
		if (windowWidth < 748) {
		} else if (windowWidth > 747 && windowWidth < 1004) {
			gsap.registerPlugin(ScrollTrigger);
			const heroCompany = document.querySelector(".hero__company--video");
			const videoElement = document.getElementById("video-element");

			// Create GSAP timeline for video element animation
			gsap.to(".hero__content", {
				y: "-150%", // Move up 100 pixels (adjust this value as needed)
				ease: "none",
				scrollTrigger: {
					trigger: ".hero__company--video",
					scrub: true,
					start: "top =+150",
					end: "bottom +=400",
				},
			});
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heroCompany,
					start: "top =+12%",
					end: "bottom =-150%",
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
					// markers: true,
				},
			});

			// Add animations to the timeline
			tl.to(videoElement, {
				position: "absolute",
				right: "0",
				bottom: "-260px",
				width: "100%",
				height: "600px",
				duration: 1,
			});
		} else if (windowWidth > 1003 && windowWidth < 1180) {
			gsap.registerPlugin(ScrollTrigger);
			const heroCompany = document.querySelector(".hero__company--video");
			const videoElement = document.getElementById("video-element");

			// Create GSAP timeline for video element animation
			gsap.to(".hero__content", {
				y: "-120%", // Move up 100 pixels (adjust this value as needed)
				ease: "none",
				scrollTrigger: {
					trigger: ".hero__company--video",
					scrub: true,
					start: "top =+150",
					end: "bottom +=400",
				},
			});
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heroCompany,
					start: "top =+12%",
					end: "bottom =-150%",
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
					// markers: true,
				},
			});

			// Add animations to the timeline
			tl.to(videoElement, {
				position: "absolute",
				right: "0",
				bottom: "-48px",
				width: "100%",
				height: "600px",
				duration: 1,
			});
		} else if (windowWidth > 1180 && windowWidth < 1345) {
			gsap.registerPlugin(ScrollTrigger);
			const heroCompany = document.querySelector(".hero__company--video");
			const videoElement = document.getElementById("video-element");

			// Create GSAP timeline for video element animation
			gsap.to(".hero__content", {
				y: "-120%", // Move up 100 pixels (adjust this value as needed)
				ease: "none",
				scrollTrigger: {
					trigger: ".hero__company--video",
					scrub: true,
					start: "top =+150",
					end: "bottom +=400",
				},
			});
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heroCompany,
					start: "top =+12%",
					end: "bottom =-150%",
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
					// markers: true,
				},
			});

			// Add animations to the timeline
			tl.to(videoElement, {
				position: "absolute",
				right: "0",
				bottom: "-48px",
				width: "100%",
				height: "600px",
				duration: 1,
			});
		} else {
			gsap.registerPlugin(ScrollTrigger);
			const heroCompany = document.querySelector(".hero__company--video");
			const videoElement = document.getElementById("video-element");

			// Create GSAP timeline for video element animation
			gsap.to(".hero__content", {
				y: "-150%", // Move up 100 pixels (adjust this value as needed)
				ease: "none",
				scrollTrigger: {
					trigger: ".hero__company--video",
					scrub: true,
					start: "top =+150",
					end: "bottom +=200",
				},
			});
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heroCompany,
					start: "top =+12%",
					end: "bottom -=300",
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
					// markers: true,
				},
			});

			// Add animations to the timeline
			tl.to(videoElement, {
				position: "absolute",
				right: "0",
				bottom: "78px",
				width: "100%",
				height: "640px",
				duration: 1,
			});
		}
	}

	/**
	 * cursor
	 */

	if (jQuery("#cursor").length > 0) {
		function curSorDesign() {
			const cursor = document.querySelector("#cursor");
			const cursorCircle = cursor.querySelector(".cursor__circle");
			const mouse = { x: -100, y: -100 };
			const pos = { x: 0, y: 0 };
			const speed = 0.1;
			const updateCoordinates = (e) => {
				mouse.x = e.clientX;
				mouse.y = e.clientY;
			};
			window.addEventListener("mousemove", updateCoordinates);
			function getAngle(diffX, diffY) {
				return (Math.atan2(diffY, diffX) * 180) / Math.PI;
			}
			function getSqueeze(diffX, diffY) {
				const distance = Math.sqrt(
					Math.pow(diffX, 2) + Math.pow(diffY, 2)
				);
				const maxSqueeze = 0.15;
				const accelerator = 1500;
				return Math.min(distance / accelerator, maxSqueeze);
			}
			const updateCursor = () => {
				const diffX = Math.round(mouse.x - pos.x);
				const diffY = Math.round(mouse.y - pos.y);
				pos.x += diffX * speed;
				pos.y += diffY * speed;
				const angle = getAngle(diffX, diffY);
				const squeeze = getSqueeze(diffX, diffY);
				const scale =
					"scale(" + (1 + squeeze) + ", " + (1 - squeeze) + ")";
				const rotate = "rotate(" + angle + "deg)";
				const translate =
					"translate3d(" + pos.x + "px ," + pos.y + "px, 0)";
				cursor.style.transform = translate;
			};
			function loop() {
				updateCursor();
				requestAnimationFrame(loop);
			}
			requestAnimationFrame(loop);
			const cursorModifiers = document.querySelectorAll("[cursor-class]");
			cursorModifiers.forEach((curosrModifier) => {
				curosrModifier.addEventListener("mouseenter", function () {
					const className = this.getAttribute("cursor-class");
					cursor.classList.add(className);
				});
				curosrModifier.addEventListener("mouseleave", function () {
					const className = this.getAttribute("cursor-class");
					cursor.classList.remove(className);
				});
			});
		}
		curSorDesign();
	}

	if (jQuery(".shuffle__cursor").length > 0) {
		function curSorDesign() {
			const cursor = document.querySelector(".shuffle__cursor");
			const cursorCircle = cursor.querySelector(".cursor__circle");
			const mouse = { x: -100, y: -100 };
			const pos = { x: 0, y: 0 };
			const speed = 0.1;

			function updateCoordinates(e) {
				mouse.x = e.clientX;
				mouse.y = e.clientY;
			}

			window.addEventListener("mousemove", updateCoordinates);

			function getAngle(diffX, diffY) {
				return (Math.atan2(diffY, diffX) * 180) / Math.PI;
			}

			function getSqueeze(diffX, diffY) {
				const distance = Math.sqrt(
					Math.pow(diffX, 2) + Math.pow(diffY, 2)
				);
				const maxSqueeze = 0.15;
				const accelerator = 1500;
				return Math.min(distance / accelerator, maxSqueeze);
			}

			const updateCursor = () => {
				const diffX = Math.round(mouse.x - pos.x);
				const diffY = Math.round(mouse.y - pos.y);
				pos.x += diffX * speed;
				pos.y += diffY * speed;
				const angle = getAngle(diffX, diffY);
				const squeeze = getSqueeze(diffX, diffY);
				const scale =
					"scale(" + (1 + squeeze) + ", " + (1 - squeeze) + ")";
				const rotate = "rotate(" + angle + "deg)";
				const translate =
					"translate3d(" + pos.x + "px ," + pos.y + "px, 0)";
				cursor.style.transform = translate;
			};

			function loop() {
				updateCursor();
				requestAnimationFrame(loop);
			}

			requestAnimationFrame(loop);

			const cursorModifiers = document.querySelectorAll("[cursor-class]");
			cursorModifiers.forEach((cursorModifier) => {
				cursorModifier.addEventListener("mouseenter", function () {
					const className = this.getAttribute("cursor-class");
					cursor.classList.add(className);
					const dataValue = this.getAttribute("data-value");
					updateCursorValue(dataValue);
				});
				cursorModifier.addEventListener("mouseleave", function () {
					const className = this.getAttribute("cursor-class");
					cursor.classList.remove(className);
				});
			});

			function updateCursorValue(value) {
				cursor.setAttribute("data-value", value);
			}
		}

		curSorDesign();
	}

	/**
	 * menu-btn
	 */

	if (jQuery(".menu-btn").length > 0) {
		const menuBtn = document.querySelector(".menu-btn");
		const navContainer = document.querySelector(".nav-overlay");
		const navLinks = document.querySelectorAll(
			".header-nav ul li, .header__socials ul li"
		);

		menuBtn.addEventListener("click", () => {
			navContainer.classList.toggle("nav-open");
			menuBtn.classList.toggle("menu-open");
			navLinks.forEach((link) => {
				link.classList.toggle("nav-link-open");
			});
		});
	}

	/**
	 * Toggle menu for mobile
	 */

	jQuery(".menu-item-has-children > a")
		.focus(function () {
			jQuery(this).siblings(".sub-menu").addClass("focused");
		})
		.blur(function () {
			jQuery(this).siblings(".sub-menu").removeClass("focused");
		});

	jQuery.noConflict();

	if (jQuery(".video__play--icon").length > 0) {
		jQuery(".video__play--icon a").magnificPopup({
			type: "inline",
			midClick: true,
			mainClass: "mfp-fade",
			class: ".video-popup",
			midClick: true,
		});
	}

	jQuery.noConflict();

	if (jQuery(".inline-video-popup").length > 0) {
		jQuery(".inline-video-popup").magnificPopup({
			type: "inline",
			midClick: true,
			mainClass: "mfp-fade",
			class: ".video-popup",
			midClick: true,
		});
	}

	jQuery.noConflict();

	// jQuery(window).scroll(function () {
	// 	const box = jQuery(".cky-box-bottom-right");
	// 	const footer = jQuery("footer");

	// 	const boxTop = box.offset().top;
	// 	const footerTop = footer.offset().top;

	// 	const windowHeight = jQuery(window).height();

	// 	if (
	// 		boxTop + box.height() > footerTop &&
	// 		boxTop < footerTop + windowHeight
	// 	) {
	// 		box.css("bottom", "20px");
	// 	}
	// });

	// jQuery.noConflict();

	if (jQuery(".open-popup-link").length > 0) {
		jQuery(".open-popup-link").magnificPopup({
			type: "inline",
			midClick: true,
			mainClass: "mfp-fade",
			class: ".team-popup",
			midClick: true,
		});
	}

	jQuery.noConflict();

	if (jQuery(".hero__gallery").length > 0) {
		function animateOnScroll() {
			const introDiv = document.querySelector(".hero__gallery");

			gsap.to(introDiv, {
				scrollTrigger: {
					trigger: introDiv,
					start: "top top", // When .scrolling__intro is at the top of the viewport
					endTrigger: "footer", // Use the footer as the end trigger
					// end: '+=100%', // When .scrolling__intro is at the bottom of the viewport
					pin: true, // Pin .scrolling__intro while in view
					pinSpacing: false, // Avoid adding extra spacing when pinning
					// markers: true,
				},
			});
		}

		animateOnScroll();
	}

	jQuery.noConflict();

	if (jQuery(".projects-faq__single").length > 0) {
		jQuery(".projects-faq__single > span").on("click", function () {
			if (jQuery(this).parent().hasClass("active")) {
				jQuery(this).parent().removeClass("active");
				jQuery(this).siblings(".projects-faq__content").slideUp();
			} else {
				jQuery(this).parent().addClass("active");
				jQuery(this).siblings(".projects-faq__content").slideDown();
			}
		});
		jQuery(".projects-faq__single > span").eq(0).trigger("click");
	}

	jQuery.noConflict();

	// jQuery( document ).mouseup( function( e ) {
	// 	const container = jQuery( '.nav-overlay' );
	// 	// if the target of the click isn't the container nor a descendant of the container
	// 	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
	// 		jQuery( '.nav-overlay' ).removeClass( 'nav-open' );
	// 	}
	// } );

	jQuery.noConflict();

	if (jQuery(".projects__swiper").length > 0) {
		if (windowWidth < 748) {
			const loadMoreBtn = jQuery("#loadmore");
			let currentItem = 3;

			const boxes = jQuery(".projects__slide");

			// Hide the "Load More" button initially if there are no more items or fewer than 4 items
			if (currentItem >= boxes.length || boxes.length < 3) {
				loadMoreBtn.hide();
				return; // No need to proceed further
			}

			loadMoreBtn.on("click", function () {
				for (
					let i = currentItem;
					i < Math.min(currentItem + 3, boxes.length);
					i++
				) {
					jQuery(boxes[i]).css("display", "inline-block");
				}

				currentItem += 3;

				// Hide the "Load More" button when all items are loaded
				if (currentItem >= boxes.length) {
					loadMoreBtn.hide();
				}
			});
		} else {
			new Swiper(".projects__swiper", {
				slidesPerView: 2,
				spaceBetween: 20,
				// freeMode: true,
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				scrollbar: {
					el: ".swiper-scrollbar",
				},
				breakpoints: {
					1023: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					800: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					580: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
				},
			});
		}
	}

	jQuery.noConflict();

	if (jQuery("a.popup-youtube").length > 0) {
		jQuery("a.popup-youtube").magnificPopup({
			disableOn: 700,
			type: "iframe",
			mainClass: "mfp-fade",
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
			variableWidth: true,
		});
	}

	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery("li").each(function () {
		if (jQuery(this).hasClass("menu-item-has-children")) {
			jQuery(this)
				.find("a:first")
				.after('<span class="submenu-icon"></span>');
		}
	});

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery(".header-nav .submenu-icon").click(function () {
		const link = jQuery(this);
		const closestUl = link.closest("ul");
		const parallelActiveLinks = closestUl.find(".active");
		const closestLi = link.closest("li");
		const linkStatus = closestLi.hasClass("active");
		let count = 0;

		closestUl.find("ul").slideUp(function () {
			if (++count === closestUl.find("ul").length) {
				parallelActiveLinks.removeClass("active");
			}
		});

		if (!linkStatus) {
			closestLi.children("ul").slideDown();
			closestLi.addClass("active");
		}
	});

	// stats

	jQuery(
		(function (jQuery, win) {
			jQuery.fn.inViewport = function (cb) {
				return this.each(function (i, el) {
					function visPx() {
						const H = jQuery(this).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call(
							el,
							Math.max(0, t > 0 ? H - t : b < H ? b : H)
						);
					}
					visPx();
					jQuery(win).on("resize scroll", visPx);
				});
			};
		})(jQuery, window)
	);

	// counter

	jQuery(function (jQuery) {
		jQuery(".count").inViewport(function (px) {
			// Make use of the `px` argument!!!
			// if element entered V.port ( px>0 ) and
			// if prop initNumAnim flag is not yet set
			//  = Animate numbers
			if (px > 0 && !this.initNumAnim) {
				this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
				jQuery(this)
					.prop("Counter", 0)
					.animate(
						{
							Counter: jQuery(this).text(),
						},
						{
							duration: 2000,
							step(now) {
								// jQuery(this).text(Math.ceil(now));
								jQuery(this).text(Math.ceil(now));
							},
						}
					);
			}
		});
	});
});
